<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import store from './store'
import {getptip} from './api/signUp.js'

export default {
  name: 'App',
  data() {
    return {
      
    }
  },
  mounted() {
    // this.getTip()
  },
  methods: {
    getTip() {
      console.log('开始调用接口')
      getptip().then(res => {
        console.log('接口响应:', res)
        const data = res.data;
        // 将数据存储到 store 的 hintText 模块
        store.commit('hintText/SET_HINTTEXT', data);
      }).catch(error => {
        console.error('接口调用失败:', error)
      });
    },
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
}
@import "./style/sass/index.scss";
</style>
